import { Component } from 'react';
import { compose } from 'recompose';
import { ChartFragment, Section } from 'models/api-response';
import { FormFieldInputType } from 'models/enum';
import { ChartActionsComponentProps, ChartComponentProps, ChartMetaFormField } from 'models/ui';
import { chartHelper } from 'helpers';
import { chartService } from 'services';
import { withChartLogic } from 'components/common';
import withSavedPatientChartsPage from 'components/features/shared/withSavedPatientChartsPage';
import { FormField, SectionTitle } from './constants';
import RespiratoryInterventionsView from './RespiratoryInterventionsView';
import { Title } from '../shared/constants';

class RespiratoryInterventions extends Component<ChartComponentProps> {
  static displayName = 'RespiratoryInterventions';

  componentDidMount() {
    this.props.initState(this.buildDefaultFormFields());
  }

  buildDefaultFormFields = (): Map<string, ChartMetaFormField> => {
    const { createFormField } = chartHelper;
    const dataMap = new Map();

    const multiselectDropdowns = [FormField.RESP_INTERVENTIONS_CARE, FormField.RESP_DRAIN_TUBE_CARE, FormField.PATIENT_RESPONSE];

    dataMap.set(FormField.NO_CARE, createFormField({ name: FormField.NO_CARE, type: FormFieldInputType.CHECK_BOX }));
    multiselectDropdowns.forEach((name) => dataMap.set(name, createFormField({ name, type: FormFieldInputType.MULTISELECT_DROPDOWN })));
    dataMap.set(FormField.CARE_NOTES, createFormField({ name: FormField.CARE_NOTES, type: FormFieldInputType.TEXT_AREA }));
    return dataMap;
  };

  createSections = (): Section[] => {
    const { formFieldMap } = this.props;
    return [
      chartHelper.buildSection({ sectionTitle: SectionTitle.RESPIRATORY_INTERVENTIONS, fields: [FormField.NO_CARE], formFieldMap }),
      chartHelper.buildSection({ sectionTitle: SectionTitle.RESPIRATORY_CARE, fields: [FormField.RESP_INTERVENTIONS_CARE], formFieldMap }),
      chartHelper.buildSection({ sectionTitle: SectionTitle.DRAIN_TUBE_CARE, fields: [FormField.RESP_DRAIN_TUBE_CARE], formFieldMap }),
      chartHelper.buildSection({ sectionTitle: SectionTitle.PATIENT_RESPONSE, fields: [FormField.PATIENT_RESPONSE], formFieldMap }),
      chartHelper.buildSection({ sectionTitle: SectionTitle.CARE_NOTES, fields: [FormField.CARE_NOTES], formFieldMap })
    ];
  };

  buildFragment = () => {
    const record = {
      chartTitle: Title.SYSTEM_NURSING_INTERVENTIONS,
      fragmentTitle: SectionTitle.RESPIRATORY_INTERVENTIONS,
      records: this.createSections()
    };
    const cleanRecord = chartService.systemAssessment.removeEmptyRecords(record);
    const basicInfo = chartService.createBaseFragment({ chartingTime: this.props.chartingTime });
    return { ...basicInfo, chartData: cleanRecord } as ChartFragment;
  };

  handleSaveClick = () => {
    this.props.saveChart([this.buildFragment()], { afterSave: this.props.backToSourceLocation || this.props.navigateToSavedPatientCharting });
  };

  render() {
    const chartActionsProps: ChartActionsComponentProps = {
      enableDisplayRecordsButton: this.props.enableDisplayRecordsButton,
      enableSaveButton: this.props.hasUnsavedChanges,
      onCancelClick: () => this.props.handleDiscardClick(undefined, this.buildDefaultFormFields()),
      onDisplayRecordsClick: this.props.displayAuthoringData,
      onSaveClick: this.handleSaveClick
    };
    const viewProps = {
      chartActionsProps,
      formFieldMap: this.props.formFieldMap,
      formSubmittedCount: this.props.formSubmittedCount
    };
    return <RespiratoryInterventionsView {...viewProps} />;
  }
}

export { RespiratoryInterventions as BaseRespiratoryInterventions };
export default compose(withSavedPatientChartsPage, withChartLogic)(RespiratoryInterventions);
